import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./sidebar.scss";
import "./sidebar-skeleton.scss";

const SidebarSkeleton = ({ className }) => {
  const classes = classNames("sidebar", "sidebar-skeleton", className);

  return (
    <div className={classes}>
      <div className="sidebar__inner">
        <div className="sidebar-skeleton__top u-padding-2">
          <div className="u-text-center">
            <div className="user-avatar-skeleton" />
            <p className="u-skeleton-text">__________________</p>
          </div>
        </div>

        <div className="sidebar-skeleton__middle u-padding-2">
          <div className="menu-item-skeleton u-margin-bottom-2">
            <p className="u-skeleton-icon u-margin-right-1" />
            <p className="menu-item-skeleton__text u-skeleton-text" />
          </div>
          <div className="menu-item-skeleton u-margin-bottom-2">
            <p className="u-skeleton-icon u-margin-right-1" />
            <p className="menu-item-skeleton__text u-skeleton-text" />
          </div>
          <div className="menu-item-skeleton u-margin-bottom-2">
            <p className="u-skeleton-icon u-margin-right-1" />
            <p className="menu-item-skeleton__text u-skeleton-text" />
          </div>
          <div className="menu-item-skeleton u-margin-bottom-2">
            <p className="u-skeleton-icon u-margin-right-1" />
            <p className="menu-item-skeleton__text u-skeleton-text" />
          </div>
          <div className="menu-item-skeleton u-margin-bottom-2">
            <p className="u-skeleton-icon u-margin-right-1" />
            <p className="menu-item-skeleton__text u-skeleton-text" />
          </div>
        </div>

        <ul className="sidebar-skeleton__bottom">
          <div className="menu-item-skeleton u-padding-1">
            <p className="menu-item-skeleton__text u-skeleton-text" />
          </div>
        </ul>
      </div>
    </div>
  );
};

SidebarSkeleton.propTypes = {
  className: PropTypes.string,
};

export default SidebarSkeleton;
